module.exports = __webpack_public_path__ + "pc/img/award2021_01.71a30898.webp";